import {HStack as ChakraHStack, StackProps} from '@chakra-ui/react'

export const HStack = (props: StackProps) => {
  return <ChakraHStack {...props}></ChakraHStack>
}
export default HStack
